<template>
  <!-- Top Black Utility Bar -->
  <nav
    class="omnibar"
    :class="{ showSidebar: isShowSidebar, mobile: isMobile }"
  >
    <div class="container omnibar__container omnibar__container--full-width">
      <div class="omnibar__group-left">
        <div class="omnibar-logo__container">
          <a :href="omnibarLogo.link">
            <img
              class="omnibar-logo__image"
              src="https://webdist.data.apnic.net/web-framework-theme/8.0.0/images/apnic-reverse.svg"
              :alt="omnibarLogo.label_en_us"
            />
          </a>
        </div>
      </div>
      <div class="omnibar__group-right">
        <!-- external links section -->
        <div class="dropdown" v-click-outside="clickOutsideOfLinksDropdown">
          <!-- external links toggle button -->
          <button
            class="omnibar-hamburger__toggle omnibar-hamburger__toggle--desktop dropdown-toggle"
            id="omnibarHamburgerButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleIsShowLinksDropdown"
          >
            <img
              class="omnibar-hamburger__icon"
              src="../../assets/icon-square-kebab.svg"
              aria-hidden="true"
            />
          </button>
          <!-- external links dropdown list -->
          <div
            v-if="isShowLinksDropdown"
            class="dropdown-menu dropdown-menu-right omnibar-quick-links__wrap d-block"
          >
            <a
              v-for="item of omnibarQuickLinks"
              :key="item.label_en_us"
              :href="item.link"
              class="dropdown-item omnibar-quick-links__link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
          </div>
        </div>
        <!-- LOG IN button -->
        <a
          v-if="!oidcIsAuthenticated && oidcAuthenticationIsChecked"
          class="omnibar-primary-action__button"
          @click="login"
        >
          <span class="omnibar-primary-action__button-text">Log in</span>
        </a>
        <!-- user profile section -->
        <div
          v-if="oidcIsAuthenticated && oidcAuthenticationIsChecked"
          class="dropdown"
          v-click-outside="clickOutsideOfUserProfileDropDown"
        >
          <!-- user profile dropdown toggle button -->
          <button
            class="dropdown-toggle omnibar-current-user__toggle"
            id="omnibarCurrentUserButton"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleIsShowUserProfileDropDown"
          >
            <fa icon="user-circle" class="user-icon"></fa>
          </button>
          <!-- user profile dropdown list -->
          <div
            v-if="isShowUserProfileDropDown"
            class="dropdown-menu dropdown-menu-right omnibar-current-user__menu d-block"
            aria-labelledby="omnibarCurrentUserButton"
          >
            <div class="omnibar-current-user__hello">
              Hello, {{ userName }}!
            </div>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              v-for="item of omnibarCurrentUserAccountLinks"
              :key="item.label_en_us"
              class="dropdown-item omnibar-current-user__menu-link"
              :href="item.link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              v-for="item of omnibarCurrentUserMembershipLinks"
              :key="item.label_en_us"
              :href="item.link"
              class="dropdown-item omnibar-current-user__menu-link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
            <a
              class="dropdown-item omnibar-primary-action__button mt-2"
              @click="signOutOidc"
            >
              <span class="omnibar-primary-action__button-text">Log out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import vClickOutside from 'v-click-outside';

export default {
  name: 'NavBar',
  props: {
    isShowSidebar: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      isShowLinksDropdown: false,
      isShowUserProfileDropDown: false,
    };
  },
  computed: {
    ...mapState(['isNarrowWidthDevice', 'themeDataList']),
    ...mapState('authStore', ['user']),
    ...mapGetters('authStore', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
    ]),

    userName() {
      if (!this.user) return '';

      return this.user.nickname || this.user.name || this.user.email || '';
    },

    omnibarQuickLinks() {
      return this.themeDataList.omnibarQuickLinks || [];
    },

    omnibarCurrentUserAccountLinks() {
      return this.themeDataList.omnibarCurrentUserAccountLinks || [];
    },

    omnibarCurrentUserMembershipLinks() {
      return this.themeDataList.omnibarCurrentUserMembershipLinks || [];
    },

    omnibarLogo() {
      return this.themeDataList.omnibarLogo || {};
    },
  },
  methods: {
    ...mapActions('authStore', ['signOutOidc', 'authenticateOidc']),
    login() {
      // The current path is recorded as prev_path in SessionStorage, and it will be used by oidcSignInCallback after login.
      const path = this.$route.fullPath;
      sessionStorage.setItem('prev_path', path);
      this.authenticateOidc();
    },
    clickOutsideOfLinksDropdown() {
      this.isShowLinksDropdown && (this.isShowLinksDropdown = false);
    },
    toggleIsShowLinksDropdown() {
      this.isShowUserProfileDropDown &&
        (this.isShowUserProfileDropDown = false);
      this.isShowLinksDropdown = !this.isShowLinksDropdown;
    },
    clickOutsideOfUserProfileDropDown() {
      this.isShowUserProfileDropDown &&
        (this.isShowUserProfileDropDown = false);
    },
    toggleIsShowUserProfileDropDown() {
      this.isShowLinksDropdown && (this.isShowLinksDropdown = false);
      this.isShowUserProfileDropDown = !this.isShowUserProfileDropDown;
    },
  },
};
</script>

<style lang="scss" scoped>
nav.omnibar {
  position: fixed;
  top: 0;
  z-index: 1003;
  width: 100%;
  margin-bottom: 0 !important;
}

.omnibar-current-user__menu {
  z-index: 9;
}

.dropdown {
  .omnibar-current-user__toggle {
    display: flex;
    align-items: center;
    padding: 0 1.9rem;
  }
  .user-icon {
    font-size: 1.6rem;
  }
}

.omnibar-primary-action__button {
  cursor: pointer;
}

.mobile.omnibar {
  position: relative;

  &.showSidebar {
    z-index: 2;
  }
}
</style>
